import apiClient from "../config/axiosConfig.js";

export async function getAllAvailableTags() {
    const res = await apiClient.get('/api/tags/getall');
    return res.data;
}

// M-F12: mutations go over POST/DELETE (previously GET, which intermediaries
// may prefetch/cache/retry). `params` also URL-encodes values properly.
export async function deleteTag(id) {
    const response = await apiClient.delete('/api/tags/delete', { params: { id } });
    return response.data;
}

// `options` is forwarded to axios so bulk callers (applying a tag across many
// selected files) can pass { skipGlobalErrorToast: true } and show a single
// summary instead of one toast per file.
export async function addTagToFile(fileId, tagId, options = {}) {
    await apiClient.post('/api/files/add-tag', null, { params: { file: fileId, tag: tagId }, ...options });
}

export async function removeTagFromFile(fileId, tagId, options = {}) {
    await apiClient.post('/api/files/remove-tag', null, { params: { file: fileId, tag: tagId }, ...options });
}

export async function createTag(tagName) {
    const response = await apiClient.post('/api/tags/create', null, { params: { name: tagName } });
    return response.data.id;
}

// Update a tag's editable fields. `patch` may contain any of:
//   { name, description, color, parents }
// `parents` is the hierarchy writer; the backend validates cycles / cross-workspace
// parents / rename collisions and returns a 400 with a human-readable message.
export async function updateTag(id, patch, options = {}) {
    const response = await apiClient.patch(`/api/tags/${encodeURIComponent(id)}`, patch, options);
    return response.data;
}

// Scan the workspace for redundant tag assignments (a file tagged with both a tag
// and one of its ancestors). Defaults to a non-destructive dry run; pass
// { dryRun: false } to actually remove the redundant ancestors. Returns the report
// { filesAffected, tagsRemoved, entries: [{ fileId, fileName, drop, keep }], applied }.
export async function cleanupRedundantTags({ dryRun = true } = {}) {
    const response = await apiClient.post('/api/tags/cleanup-redundant', null, { params: { dryRun } });
    return response.data;
}
